// ─────────────────────────────────────────────────────────────────────────────
// API Configuration
// ─────────────────────────────────────────────────────────────────────────────

const isDev = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// Get the base URL for API calls
const getApiBase = () => {
  if (typeof window === 'undefined') return '';
  
  const origin = window.location.origin;
  const hostname = window.location.hostname;
  
  // On localhost, include /as subfolder path
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://localhost:80/AS/backend/api`;
  }
  
  // On production (abhayasri.com), backend is at /backend/api
  return `${origin}/backend/api`;
};

// ─────────────────────────────────────────────────────────────────────────────
// Exports
// ─────────────────────────────────────────────────────────────────────────────

export const API_BASE = getApiBase();
export const API_ADMIN = `${API_BASE}/admin`;
export const UPLOAD_URL = `${API_ADMIN}/upload_image.php`;
export const UPLOAD_MEDIA_URL = `${API_ADMIN}/upload_media.php`;
export const UPDATE_CONTENT_URL = `${API_ADMIN}/update_content.php`;
export const GET_CONTENT_URL = `${API_BASE}/get_content.php`;
export const SEND_EMAIL_URL = `${API_BASE}/send_email.php`;
